module.exports = __webpack_public_path__ + "img/img_15.ce4502b5.png";